
/*Notification Types*/
export const SUCCESS = "SUCCESS";
export const ERROR = "ERROR";
export const ACTION = "ACTION";
export const WARNING ="WARNING";
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION"